<template>
  <div v-loading.fullscreen.lock="isLoading">
    <div style="margin-left: 7em; margin-right: 7em">
      <el-form ref="form" :model="addForm">
        <el-row>
          <el-form-item
            label="學號"
            required
            style="margin-bottom: -1em"
          ></el-form-item>

          <el-input
            style="margin-bottom: 1em"
            placeholder="請輸入學號"
            v-model="addForm.studentID"
          ></el-input>

          <el-form-item
            label="法名"
            style="margin-bottom: -1em; margin-left: 10px"
          ></el-form-item>
          <el-input
            style="margin-bottom: 1em"
            placeholder="請輸入法名"
            v-model="addForm.sgName"
          ></el-input>

          <el-form-item
            label="姓"
            style="margin-bottom: -1em; margin-left: 10px"
          ></el-form-item>
          <el-input
            style="margin-bottom: 1em"
            placeholder="請輸入姓"
            v-model="addForm.nameL"
          ></el-input>

          <el-form-item
            label="名"
            required
            style="margin-bottom: -1em"
          ></el-form-item>
          <el-input
            style="margin-bottom: 1em"
            placeholder="請輸入名"
            v-model="addForm.name"
          ></el-input>

          <el-form-item
            v-if="role || id==''"
            label="新身份識別碼"
            style="margin-bottom: -1em"
          >
          </el-form-item>
          <el-input
            v-if="role || id==''"
            style="margin-bottom: 1em"
            clearable
            placeholder="請輸入身份識別碼"
            v-model="addForm.identifier"
            :disabled="addForm.identifierC"
          ></el-input>

          <el-checkbox  v-if="id!='' && role" v-model="addForm.identifierC">清除身份識別碼</el-checkbox>

          <el-form-item
            label="生活班"
            required
            style="margin-bottom: -1em"
          ></el-form-item>
          <el-select
            v-model="addForm.lifeClass"
            placeholder="請選擇生活班"
            style="display: block; width: 100%; margin-bottom: 1em"
          >
            <el-option
              v-for="item in lifeClass"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button @click="closeDialog(true)">取消</el-button>
          <el-button
            v-if="id==''"
            id="test_lifeClass_btAddgo"
            @click="check(false)"
            type="primary"
            >新增</el-button
          >
          <el-button
            v-else
            id="test_lifeClass_btAddgo"
            @click="check(false)"
            type="primary"
            >儲存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import API from "@/api/";
import Utils from "@/utils";
import { InformType } from "@/utils/InformType";

export default {
  name: "personAdd",
  props: {
    clickTime: Date,
    id: { String, default: '' },
  },
  watch: {
    clickTime: function () {
      console.log("clickTime watch");
      console.log("id", this.id);
      console.log("NaN", this.id=='');
      console.log("role", this.role);
      this.query();
    },
  },
  created: function () {
    this.query();
    this.getlideClass();
  },
  data() {
    return {
      role: Utils.Auth.hasRole(["ROLE_PERSON_ADMIN", "ROLE_ADMIN"]),
      isLoading: false,
      lifeClass: [],
      addForm: {
        studentID: "",
        nameL: "",
        name: "",
        sgName: "",
        identifier: "",
        lifeClass: "",
        identifierC: false,
      },
    };
  },
  methods: {
    query() {
      if (this.id) {
        console.log("讀取");
        this.isLoading = true;
        API.person.show(this.id).then((res) => {
          this.addForm = res.data;
          this.addForm.identifier = "";
          this.$set(this.addForm, 'identifierC', false);
          this.isLoading = false;
        });
      } else {
        this.addForm = {
          studentID: "",
          nameL: "",
          name: "",
          sgName: "",
          identifier: "",
          lifeClass: "",
          identifierC: false
        };
      }
    },
    getlideClass() {
      console.log("讀取生活班");
      API.lifeClass.findLifeClass().then((res) => {
        this.lifeClass = res.data;
      });
    },
    closeDialog(c) {
      if (c) this.$emit("close", this.id);
      else this.$emit("close", this.addForm.studentID);
    },
    check() {
      if (Utils.Check.isNull(this.addForm.studentID) && this.id=='') {
        Utils.Message.send("學號不能為空!", InformType.ERROR);
        return;
      }

      if (this.addForm.studentID.length < 6 ) {
        Utils.Message.send("學號過短!", InformType.ERROR);
        return;
      }

      if (Utils.Check.isNull(this.addForm.name)) {
        Utils.Message.send("名不能為空!", InformType.ERROR);
        return;
      }

      // 取消身份識別碼必填
      // if (Utils.Check.isNull(this.addForm.identifier)&&isNaN(this.id) ) {
      //   Utils.Message.send("身份識別碼不能為空!", InformType.ERROR);
      //   return;}

      if (Utils.Check.isNull(this.addForm.lifeClass)) {
        Utils.Message.send("生活班不能為空!", InformType.ERROR);
        return;
      }

      console.log("檢查成功");
      //去空白
      this.addForm.studentID = this.addForm.studentID.replaceAll(/\s+/g, "");
      this.addForm.identifier = this.addForm.identifier.replaceAll(/\s+/g, "");
      this.update();
    },
    update() {
      if (this.id) {
        console.log("修改", this.id, this.addForm);
        this.isLoading = true;
        API.person
          .update(this.id, this.addForm)
          .then(() => {
            Utils.Message.send("修改人員成功!", InformType.SUCCESS);
            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        console.log("新增");
        this.isLoading = true;
        API.person
          .add(this.addForm)
          .then(() => {
            Utils.Message.send("新增人員成功!", InformType.SUCCESS);
            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style>
</style>